export default "__VITE_ASSET__bef0c49d__$_?inline__"